var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreater(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 18,
    viewBox: "0 0 11 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2509 9.75157L10.2507 9.7517L2.75073 17.2517C2.5511 17.4513 2.28036 17.5635 1.99805 17.5635C1.71573 17.5635 1.44499 17.4513 1.24536 17.2517C1.04574 17.0521 0.933594 16.7813 0.933594 16.499C0.933594 16.2167 1.04574 15.946 1.24536 15.7463L7.94942 9.04416L7.99362 8.99997L7.94943 8.95577L1.24725 2.25171L1.24724 2.2517C1.1484 2.15286 1.06999 2.03551 1.0165 1.90637C0.963001 1.77722 0.935468 1.63881 0.935468 1.49902C0.935468 1.35924 0.963001 1.22082 1.0165 1.09167C1.06999 0.962529 1.1484 0.845185 1.24724 0.746341C1.34608 0.647498 1.46343 0.569091 1.59257 0.515597C1.72172 0.462103 1.86013 0.43457 1.99992 0.43457C2.13971 0.43457 2.27812 0.462103 2.40727 0.515597C2.53641 0.569091 2.65376 0.647498 2.7526 0.746341L10.2526 8.24634L10.2526 8.24637C10.3516 8.34519 10.43 8.46258 10.4835 8.59179C10.537 8.721 10.5644 8.8595 10.5642 8.99934C10.5641 9.13918 10.5363 9.27761 10.4825 9.4067C10.4288 9.53578 10.35 9.65298 10.2509 9.75157Z",
    fill: "#094063",
    stroke: "#094063",
    strokeWidth: 0.125
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreater);
export default __webpack_public_path__ + "static/media/Greater.7bd8fdfae5109ffbd5deb912d03b72b8.svg";
export { ForwardRef as ReactComponent };